import React, { Component } from 'react';

import IconCheck from '../icons/icon-check';

export default class Checkbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: props.checked || false
        };
    }

    handleClick = () => {
        if (this.props.disabled || this.props.readonly) {
            return;
        }

        this.change(!this.checked)
    }

    handleChange = event => {
        this.change(event.target.checked);
    }

    change(checked) {
        if (this.checked === checked) {
            return;
        }

        this.setState({ checked });
        this.props.onChange && this.props.onChange(checked);
    }

    get checked() {
        if (this.props.forceUseProp) {
            return this.props.checked;
        }

        return this.state.checked;
    }

    componentDidUpdate(prevProps) {
        if (this.props.checked !== prevProps.checked && this.props.checked !== this.state.checked) {
            this.setState({
                checked: this.props.checked
            });
        }
    }

    render() {
        return (
            <span className={'checkbox' + (this.checked ? ' checked' : '') + (this.props.inverted ? ' inverted' : '') + (this.props.disabled ? ' disabled' : '') + (this.props.alwaysTick ? ' always-tick' : '') + (this.props.plain ? ' plain' : '') + (this.props.dark ? ' dark' : '') + (this.props.tickOnly ? ' tick-only' : '')} onClick={this.handleClick}>
                {
                    this.props.id ? <input type="checkbox" id={this.props.id} disabled={this.props.disabled} checked={this.checked} onChange={this.handleChange} /> : null
                }

                <span className="checkbox-tick">
                    <IconCheck />
                </span>
            </span>
        );
    }
}
